import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ContentChild, forwardRef, ViewChild, Directive, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i4 from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { fromEvent } from 'rxjs';
import * as i5 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1 from '@eui/core';

class UxModalComponent {
    constructor(asService) {
        this.asService = asService;
        this.dismissActionLabel = 'Cancel';
        this._dismissActionDisabled = false;
        this.acceptActionLabel = 'OK';
        this._acceptActionDisabled = false;
        this._isFooterVisible = true;
        this._isVisible = false;
        this._isKeepBodyScroll = false;
        this._isSizeSmall = false;
        this._isSizeLarge = false;
        this._isSizeFullScreen = false;
        this._isSizeFullHeight = false;
        this._isSizeMediumHeight = false;
        this._isShowActionIcons = false;
        this.acceptIconClass = 'eui-icon eui-icon-check';
        this.dismissIconClass = 'eui-icon eui-icon-times';
        this._hasNoBodyPadding = false;
        this._isFooterCustomAlignment = false;
        this._isCloseModalOnEscape = true;
        this._isShowCloseButton = true;
        this._isMessageBox = false;
        this.e2eAttr = 'ux-modal';
        this._isDraggable = false;
        this._isHandleCloseOnDismiss = true;
        this._isHandleCloseOnAccept = true;
        this._isHandleCloseOnClose = true;
        this._isOverflowVisible = false;
        this._isDismissActionVisible = true;
        this._isAcceptActionVisible = true;
        this.onDismiss = new EventEmitter();
        this.onAccept = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onOpen = new EventEmitter();
        this.onAnimationEnd = new EventEmitter();
        // modal states
        this.stateClasses = '';
    }
    get dismissActionDisabled() { return this._dismissActionDisabled; }
    set dismissActionDisabled(value) { this._dismissActionDisabled = coerceBooleanProperty(value); }
    get acceptActionDisabled() { return this._acceptActionDisabled; }
    set acceptActionDisabled(value) { this._acceptActionDisabled = coerceBooleanProperty(value); }
    get isFooterVisible() { return this._isFooterVisible; }
    set isFooterVisible(value) { this._isFooterVisible = coerceBooleanProperty(value); }
    get isVisible() { return this._isVisible; }
    set isVisible(value) { this._isVisible = coerceBooleanProperty(value); }
    get isKeepBodyScroll() { return this._isKeepBodyScroll; }
    set isKeepBodyScroll(value) { this._isKeepBodyScroll = coerceBooleanProperty(value); }
    get isSizeSmall() { return this._isSizeSmall; }
    set isSizeSmall(value) { this._isSizeSmall = coerceBooleanProperty(value); }
    get isSizeLarge() { return this._isSizeLarge; }
    set isSizeLarge(value) { this._isSizeLarge = coerceBooleanProperty(value); }
    get isSizeFullScreen() { return this._isSizeFullScreen; }
    set isSizeFullScreen(value) { this._isSizeFullScreen = coerceBooleanProperty(value); }
    get isSizeFullHeight() { return this._isSizeFullHeight; }
    set isSizeFullHeight(value) { this._isSizeFullHeight = coerceBooleanProperty(value); }
    get isSizeMediumHeight() { return this._isSizeMediumHeight; }
    set isSizeMediumHeight(value) { this._isSizeMediumHeight = coerceBooleanProperty(value); }
    get isShowActionIcons() { return this._isShowActionIcons; }
    set isShowActionIcons(value) { this._isShowActionIcons = coerceBooleanProperty(value); }
    get hasNoBodyPadding() { return this._hasNoBodyPadding; }
    set hasNoBodyPadding(value) { this._hasNoBodyPadding = coerceBooleanProperty(value); }
    get isFooterCustomAlignment() { return this._isFooterCustomAlignment; }
    set isFooterCustomAlignment(value) { this._isFooterCustomAlignment = coerceBooleanProperty(value); }
    get isCloseModalOnEscape() { return this._isCloseModalOnEscape; }
    set isCloseModalOnEscape(value) { this._isCloseModalOnEscape = coerceBooleanProperty(value); }
    get isShowCloseButton() { return this._isShowCloseButton; }
    set isShowCloseButton(value) { this._isShowCloseButton = coerceBooleanProperty(value); }
    get isMessageBox() { return this._isMessageBox; }
    set isMessageBox(value) { this._isMessageBox = coerceBooleanProperty(value); }
    get isDraggable() { return this._isDraggable; }
    set isDraggable(value) { this._isDraggable = coerceBooleanProperty(value); }
    get isHandleCloseOnDismiss() { return this._isHandleCloseOnDismiss; }
    set isHandleCloseOnDismiss(value) { this._isHandleCloseOnDismiss = coerceBooleanProperty(value); }
    get isHandleCloseOnAccept() { return this._isHandleCloseOnAccept; }
    set isHandleCloseOnAccept(value) { this._isHandleCloseOnAccept = coerceBooleanProperty(value); }
    get isHandleCloseOnClose() { return this._isHandleCloseOnClose; }
    set isHandleCloseOnClose(value) { this._isHandleCloseOnClose = coerceBooleanProperty(value); }
    get isOverflowVisible() { return this._isOverflowVisible; }
    set isOverflowVisible(value) { this._isOverflowVisible = coerceBooleanProperty(value); }
    get isDismissActionVisible() { return this._isDismissActionVisible; }
    set isDismissActionVisible(value) { this._isDismissActionVisible = coerceBooleanProperty(value); }
    get isAcceptActionVisible() { return this._isAcceptActionVisible; }
    set isAcceptActionVisible(value) { this._isAcceptActionVisible = coerceBooleanProperty(value); }
    get isModalOpen() {
        if (this.asService.isModalOpen(this.id)) {
            return true;
        }
        return false;
    }
    ngAfterContentInit() {
        if (this.isVisible) {
            this.asService.openModal(this.id);
        }
        // setting modal states
        if (this.isSizeSmall) {
            this.stateClasses = 'ux-modal--small';
        }
        if (this.isSizeLarge) {
            this.stateClasses = 'ux-modal--large';
        }
        if (this.isSizeFullScreen) {
            this.stateClasses = 'ux-modal--full-screen';
        }
        if (!this.isAcceptActionVisible && !this.isDismissActionVisible) {
            this.isFooterVisible = false;
        }
    }
    ngAfterViewInit() {
        const modalEl = this.uxModalEl.nativeElement;
        this.animationEndSubscription = fromEvent(modalEl, 'animationend').subscribe(() => {
            this.onAnimationEnd.next(void 0);
            this.onOpen.emit(true);
        });
    }
    ngOnDestroy() {
        if (this.openModalIdSubscription) {
            this.openModalIdSubscription.unsubscribe();
        }
        if (this.animationEndSubscription) {
            this.animationEndSubscription.unsubscribe();
        }
        if (this.asService.isModalOpen(this.id)) {
            this.close({});
        }
    }
    close(event) {
        if (this.isHandleCloseOnClose) {
            this.asService.closeModal(this.id);
        }
        this.onClose.emit(event);
    }
    closeModalOnEscape(event) {
        if (this.isCloseModalOnEscape) {
            if (event.keyCode === 27) { // 27 = escape
                this.close(event);
            }
        }
    }
    onAcceptActionClick(event) {
        if (this.isHandleCloseOnAccept) {
            this.asService.closeModal(this.id);
        }
        this.onAccept.emit(event);
    }
    onDismissActionClick(event) {
        if (this.isHandleCloseOnDismiss) {
            this.asService.closeModal(this.id);
        }
        this.onDismiss.emit(event);
    }
}
/** @nocollapse */ UxModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalComponent, deps: [{ token: i1.UxAppShellService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxModalComponent, selector: "ux-modal", inputs: { id: "id", styleClass: "styleClass", titleLabel: "titleLabel", dismissActionLabel: "dismissActionLabel", dismissActionDisabled: "dismissActionDisabled", acceptActionLabel: "acceptActionLabel", acceptActionDisabled: "acceptActionDisabled", isFooterVisible: "isFooterVisible", isVisible: "isVisible", isKeepBodyScroll: "isKeepBodyScroll", isSizeSmall: "isSizeSmall", isSizeLarge: "isSizeLarge", isSizeFullScreen: "isSizeFullScreen", isSizeFullHeight: "isSizeFullHeight", isSizeMediumHeight: "isSizeMediumHeight", isShowActionIcons: "isShowActionIcons", acceptIconClass: "acceptIconClass", dismissIconClass: "dismissIconClass", hasNoBodyPadding: "hasNoBodyPadding", customWidth: "customWidth", isFooterCustomAlignment: "isFooterCustomAlignment", isCloseModalOnEscape: "isCloseModalOnEscape", isShowCloseButton: "isShowCloseButton", isMessageBox: "isMessageBox", e2eAttr: "e2eAttr", isDraggable: "isDraggable", isHandleCloseOnDismiss: "isHandleCloseOnDismiss", isHandleCloseOnAccept: "isHandleCloseOnAccept", isHandleCloseOnClose: "isHandleCloseOnClose", bodyStyleClass: "bodyStyleClass", footerStyleClass: "footerStyleClass", isOverflowVisible: "isOverflowVisible", isDismissActionVisible: "isDismissActionVisible", isAcceptActionVisible: "isAcceptActionVisible" }, outputs: { onDismiss: "onDismiss", onAccept: "onAccept", onClose: "onClose", onOpen: "onOpen", onAnimationEnd: "onAnimationEnd" }, queries: [{ propertyName: "customFooterContent", first: true, predicate: i0.forwardRef(function () { return UxModalFooterTagDirective; }), descendants: true }, { propertyName: "customHeaderContent", first: true, predicate: i0.forwardRef(function () { return UxModalHeaderTagDirective; }), descendants: true }], viewQueries: [{ propertyName: "uxModalEl", first: true, predicate: ["modal"], descendants: true }, { propertyName: "vcCloseButton", first: true, predicate: ["closeButton"], descendants: true }], ngImport: i0, template: `
        <div #modal id="{{id}}" cdkTrapFocus class="ux-modal {{styleClass}} {{stateClasses}} eui-u-anim"
            [class.show]="isModalOpen"
            [class.eui-u-anim--slideInDown]="!isMessageBox"
            [class.eui-u-anim--fast]="!isMessageBox"
            [class.eui-u-anim--flipInY]="isMessageBox"
            [class.eui-u-anim--medium]="isMessageBox"
            [class.ux-modal--full-height]="isSizeFullHeight"
            [class.ux-modal--medium-height]="isSizeMediumHeight"
            [class.ux-modal--draggable]="isDraggable"
            [attr.aria-hidden]="!isModalOpen"
            [style.display]="isModalOpen ? 'block' : 'none'"
            (keydown)="closeModalOnEscape($event)"
            role="dialog"
            [tabIndex]="!isModalOpen ? -1 : 0"
            attr.data-e2e="{{ e2eAttr }}">
            <div class="ux-modal__dialog" role="document" [style.max-width]="customWidth" cdkDrag [cdkDragDisabled]="!isDraggable">
                <div class="ux-modal__content" [class.ux-u-overflow-visible]="isOverflowVisible">
                    <div class="ux-modal__header" cdkDragHandle>
                        <ng-template [ngIf]="customHeaderContent">
                            <ng-content select="uxModalHeader"></ng-content>
                        </ng-template>
                        <ng-template [ngIf]="!customHeaderContent">
                            <div class="ux-modal__header-title">{{titleLabel}}</div>
                        </ng-template>
                        <button #closeButton type="button"
                                id="{{id}}-close-button"
                                class="ux-modal__header-close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="close($event)"
                                [class.disabled]="!isShowCloseButton">
                            <span class="eui-icon eui-icon-close-m"></span>
                        </button>
                    </div>
                    <div class="ux-modal__body {{bodyStyleClass}}"
                         [class.ux-modal--no-padding]="hasNoBodyPadding"
                         [class.ux-u-overflow-visible]="isOverflowVisible" cdkScrollable>
                        <ng-content select="uxModalBody"></ng-content>
                    </div>
                    <div *ngIf="isFooterVisible"
                         class="ux-modal__footer {{footerStyleClass}}"
                         [class.ux-modal__footer--custom-alignment]="isFooterCustomAlignment">
                        <ng-template [ngIf]="customFooterContent">
                            <ng-content select="uxModalFooter"></ng-content>
                        </ng-template>
                        <ng-template [ngIf]="!customFooterContent">
                            <button *ngIf="isDismissActionVisible"
                                    type="button"
                                    class="ux-button ux-button--secondary"
                                    [class.ux-button--with-label]="isShowActionIcons"
                                    [disabled]="dismissActionDisabled"
                                    (click)="onDismissActionClick($event)">
                                <span *ngIf="isShowActionIcons" class="ux-button__icon {{dismissIconClass}}"></span>
                                {{dismissActionLabel}}
                            </button>
                            <button *ngIf="isAcceptActionVisible"
                                    type="button"
                                    class="ux-button ux-button--primary"
                                    [class.ux-button--with-label]="isShowActionIcons"
                                    [disabled]="acceptActionDisabled"
                                    (click)="onAcceptActionClick($event)">
                                <span *ngIf="isShowActionIcons" class="ux-button__icon {{acceptIconClass}}"></span>
                                {{acceptActionLabel}}
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop" [class.show]="isModalOpen"
             [ngClass]="{fade: isModalOpen, in: isModalOpen}"
             [style.display]="isModalOpen ? 'block' : 'none'" (focus)="close($event)"></div>
    `, isInline: true, styles: [".ux-modal{inset:0;outline:0;overflow:hidden;position:fixed;z-index:var(--eui-base-z-index-modal)}.ux-modal__content{background-clip:padding-box;background-color:var(--eui-base-color-white);border:1px solid var(--eui-base-color-grey-10);border-radius:var(--eui-base-border-radius);display:flex;flex-direction:column;max-height:100%;outline:0;overflow:auto;pointer-events:auto;position:relative;width:100%;box-shadow:var(--eui-base-shadow-24)}.ux-modal__dialog{display:flex;flex-direction:column;height:100vh;justify-content:center;margin:1.75rem auto;margin-bottom:0;margin-top:0;max-width:50%;pointer-events:none;position:relative;width:auto}.ux-modal__header{align-items:center;border-bottom:1px solid var(--eui-base-color-grey-10);border-top-left-radius:var(--eui-border-radius-base);border-top-right-radius:var(--eui-border-radius-base);display:flex;justify-content:space-between;min-height:calc(4 * var(--eui-base-spacing-m));padding:var(--eui-base-spacing-s) var(--eui-base-spacing-m)}.ux-modal--draggable .ux-modal__header{cursor:move}.ux-modal__header-title{font-size:var(--eui-base-font-size-xl);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-style:normal;font-weight:700}.ux-modal__body{flex:1 1 auto;overflow:auto;padding:var(--eui-base-spacing-m);position:relative}.ux-modal__body.ux-modal--no-padding{padding:0}.ux-modal__footer{background-color:var(--eui-base-color-grey-5);border-top:1px solid var(--eui-base-color-grey-10);justify-content:flex-end;padding:var(--eui-base-spacing-s);align-items:center;display:flex;width:100%}.ux-modal__footer--custom-alignment{display:block}.ux-modal__footer button:not(:last-child){margin-right:var(--eui-base-spacing-xs)}.ux-modal__header-close{background-color:transparent;border:none;box-shadow:none;color:var(--eui-base-color-grey-25);font-size:var(--eui-base-font-size-2xl);margin-right:calc(-1 * var(--eui-base-spacing-s));outline:0;padding:var(--eui-base-spacing-2xs) var(--eui-base-spacing-xs)}.ux-modal__header-close:hover{color:var(--eui-base-color-text)}.ux-modal__header-close:active,.ux-modal__header-close:focus{outline:2px solid var(--eui-base-color-accessible-focus);outline-offset:-2px;-moz-outline-radius:var(--eui-base-border-radius);transition:outline .15s ease-in-out,border .15s ease-in-out}.ux-modal__header-close.disabled{display:none}uxmodalheader{display:flex;width:100%}.ux-modal--small .ux-modal__dialog{max-width:33%}.ux-modal--large .ux-modal__dialog{max-width:75%}.ux-modal--full-screen .ux-modal__content{height:98%;margin:1.5%;width:97%}.ux-modal--full-screen .ux-modal__dialog{height:100%;max-height:100%;max-width:100%;width:100%}.ux-modal--full-height{max-height:100%}.ux-modal--full-height .ux-modal__dialog{height:100%}.ux-modal--full-height .ux-modal__content{height:95%}.ux-modal--full-height .ux-modal__body{overflow-x:hidden;overflow-y:scroll}.ux-modal--medium-height{max-height:100%}.ux-modal--medium-height .ux-modal__dialog{height:100%}.ux-modal--medium-height .ux-modal__content{height:50%}.ux-modal--medium-height .ux-modal__body{overflow-x:hidden;overflow-y:scroll}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-open .cdk-overlay-container{z-index:var(--eui-base-z-index-cdk-overlay-container)}.modal-backdrop{background-color:#00000080;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .5s cubic-bezier(.25,.8,.25,1);width:100vw;z-index:var(--eui-base-z-index-modal-backdrop)}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:var(--eui-base-disabled-opacity)}@media screen and (max-width: 995px){.ux-modal__dialog,.ux-modal__dialog[style],.ux-modal--small .ux-modal__dialog,.ux-modal--big .ux-modal__dialog,.ux-modal--full-screen .ux-modal__dialog{margin-left:1.5%;max-width:100%!important;width:97%!important}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "directive", type: i4.CdkScrollable, selector: "[cdk-scrollable], [cdkScrollable]" }, { kind: "directive", type: i5.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i5.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-modal', template: `
        <div #modal id="{{id}}" cdkTrapFocus class="ux-modal {{styleClass}} {{stateClasses}} eui-u-anim"
            [class.show]="isModalOpen"
            [class.eui-u-anim--slideInDown]="!isMessageBox"
            [class.eui-u-anim--fast]="!isMessageBox"
            [class.eui-u-anim--flipInY]="isMessageBox"
            [class.eui-u-anim--medium]="isMessageBox"
            [class.ux-modal--full-height]="isSizeFullHeight"
            [class.ux-modal--medium-height]="isSizeMediumHeight"
            [class.ux-modal--draggable]="isDraggable"
            [attr.aria-hidden]="!isModalOpen"
            [style.display]="isModalOpen ? 'block' : 'none'"
            (keydown)="closeModalOnEscape($event)"
            role="dialog"
            [tabIndex]="!isModalOpen ? -1 : 0"
            attr.data-e2e="{{ e2eAttr }}">
            <div class="ux-modal__dialog" role="document" [style.max-width]="customWidth" cdkDrag [cdkDragDisabled]="!isDraggable">
                <div class="ux-modal__content" [class.ux-u-overflow-visible]="isOverflowVisible">
                    <div class="ux-modal__header" cdkDragHandle>
                        <ng-template [ngIf]="customHeaderContent">
                            <ng-content select="uxModalHeader"></ng-content>
                        </ng-template>
                        <ng-template [ngIf]="!customHeaderContent">
                            <div class="ux-modal__header-title">{{titleLabel}}</div>
                        </ng-template>
                        <button #closeButton type="button"
                                id="{{id}}-close-button"
                                class="ux-modal__header-close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="close($event)"
                                [class.disabled]="!isShowCloseButton">
                            <span class="eui-icon eui-icon-close-m"></span>
                        </button>
                    </div>
                    <div class="ux-modal__body {{bodyStyleClass}}"
                         [class.ux-modal--no-padding]="hasNoBodyPadding"
                         [class.ux-u-overflow-visible]="isOverflowVisible" cdkScrollable>
                        <ng-content select="uxModalBody"></ng-content>
                    </div>
                    <div *ngIf="isFooterVisible"
                         class="ux-modal__footer {{footerStyleClass}}"
                         [class.ux-modal__footer--custom-alignment]="isFooterCustomAlignment">
                        <ng-template [ngIf]="customFooterContent">
                            <ng-content select="uxModalFooter"></ng-content>
                        </ng-template>
                        <ng-template [ngIf]="!customFooterContent">
                            <button *ngIf="isDismissActionVisible"
                                    type="button"
                                    class="ux-button ux-button--secondary"
                                    [class.ux-button--with-label]="isShowActionIcons"
                                    [disabled]="dismissActionDisabled"
                                    (click)="onDismissActionClick($event)">
                                <span *ngIf="isShowActionIcons" class="ux-button__icon {{dismissIconClass}}"></span>
                                {{dismissActionLabel}}
                            </button>
                            <button *ngIf="isAcceptActionVisible"
                                    type="button"
                                    class="ux-button ux-button--primary"
                                    [class.ux-button--with-label]="isShowActionIcons"
                                    [disabled]="acceptActionDisabled"
                                    (click)="onAcceptActionClick($event)">
                                <span *ngIf="isShowActionIcons" class="ux-button__icon {{acceptIconClass}}"></span>
                                {{acceptActionLabel}}
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop" [class.show]="isModalOpen"
             [ngClass]="{fade: isModalOpen, in: isModalOpen}"
             [style.display]="isModalOpen ? 'block' : 'none'" (focus)="close($event)"></div>
    `, encapsulation: ViewEncapsulation.None, styles: [".ux-modal{inset:0;outline:0;overflow:hidden;position:fixed;z-index:var(--eui-base-z-index-modal)}.ux-modal__content{background-clip:padding-box;background-color:var(--eui-base-color-white);border:1px solid var(--eui-base-color-grey-10);border-radius:var(--eui-base-border-radius);display:flex;flex-direction:column;max-height:100%;outline:0;overflow:auto;pointer-events:auto;position:relative;width:100%;box-shadow:var(--eui-base-shadow-24)}.ux-modal__dialog{display:flex;flex-direction:column;height:100vh;justify-content:center;margin:1.75rem auto;margin-bottom:0;margin-top:0;max-width:50%;pointer-events:none;position:relative;width:auto}.ux-modal__header{align-items:center;border-bottom:1px solid var(--eui-base-color-grey-10);border-top-left-radius:var(--eui-border-radius-base);border-top-right-radius:var(--eui-border-radius-base);display:flex;justify-content:space-between;min-height:calc(4 * var(--eui-base-spacing-m));padding:var(--eui-base-spacing-s) var(--eui-base-spacing-m)}.ux-modal--draggable .ux-modal__header{cursor:move}.ux-modal__header-title{font-size:var(--eui-base-font-size-xl);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-style:normal;font-weight:700}.ux-modal__body{flex:1 1 auto;overflow:auto;padding:var(--eui-base-spacing-m);position:relative}.ux-modal__body.ux-modal--no-padding{padding:0}.ux-modal__footer{background-color:var(--eui-base-color-grey-5);border-top:1px solid var(--eui-base-color-grey-10);justify-content:flex-end;padding:var(--eui-base-spacing-s);align-items:center;display:flex;width:100%}.ux-modal__footer--custom-alignment{display:block}.ux-modal__footer button:not(:last-child){margin-right:var(--eui-base-spacing-xs)}.ux-modal__header-close{background-color:transparent;border:none;box-shadow:none;color:var(--eui-base-color-grey-25);font-size:var(--eui-base-font-size-2xl);margin-right:calc(-1 * var(--eui-base-spacing-s));outline:0;padding:var(--eui-base-spacing-2xs) var(--eui-base-spacing-xs)}.ux-modal__header-close:hover{color:var(--eui-base-color-text)}.ux-modal__header-close:active,.ux-modal__header-close:focus{outline:2px solid var(--eui-base-color-accessible-focus);outline-offset:-2px;-moz-outline-radius:var(--eui-base-border-radius);transition:outline .15s ease-in-out,border .15s ease-in-out}.ux-modal__header-close.disabled{display:none}uxmodalheader{display:flex;width:100%}.ux-modal--small .ux-modal__dialog{max-width:33%}.ux-modal--large .ux-modal__dialog{max-width:75%}.ux-modal--full-screen .ux-modal__content{height:98%;margin:1.5%;width:97%}.ux-modal--full-screen .ux-modal__dialog{height:100%;max-height:100%;max-width:100%;width:100%}.ux-modal--full-height{max-height:100%}.ux-modal--full-height .ux-modal__dialog{height:100%}.ux-modal--full-height .ux-modal__content{height:95%}.ux-modal--full-height .ux-modal__body{overflow-x:hidden;overflow-y:scroll}.ux-modal--medium-height{max-height:100%}.ux-modal--medium-height .ux-modal__dialog{height:100%}.ux-modal--medium-height .ux-modal__content{height:50%}.ux-modal--medium-height .ux-modal__body{overflow-x:hidden;overflow-y:scroll}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-open .cdk-overlay-container{z-index:var(--eui-base-z-index-cdk-overlay-container)}.modal-backdrop{background-color:#00000080;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .5s cubic-bezier(.25,.8,.25,1);width:100vw;z-index:var(--eui-base-z-index-modal-backdrop)}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:var(--eui-base-disabled-opacity)}@media screen and (max-width: 995px){.ux-modal__dialog,.ux-modal__dialog[style],.ux-modal--small .ux-modal__dialog,.ux-modal--big .ux-modal__dialog,.ux-modal--full-screen .ux-modal__dialog{margin-left:1.5%;max-width:100%!important;width:97%!important}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.UxAppShellService }]; }, propDecorators: { id: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], titleLabel: [{
                type: Input
            }], dismissActionLabel: [{
                type: Input
            }], dismissActionDisabled: [{
                type: Input
            }], acceptActionLabel: [{
                type: Input
            }], acceptActionDisabled: [{
                type: Input
            }], isFooterVisible: [{
                type: Input
            }], isVisible: [{
                type: Input
            }], isKeepBodyScroll: [{
                type: Input
            }], isSizeSmall: [{
                type: Input
            }], isSizeLarge: [{
                type: Input
            }], isSizeFullScreen: [{
                type: Input
            }], isSizeFullHeight: [{
                type: Input
            }], isSizeMediumHeight: [{
                type: Input
            }], isShowActionIcons: [{
                type: Input
            }], acceptIconClass: [{
                type: Input
            }], dismissIconClass: [{
                type: Input
            }], hasNoBodyPadding: [{
                type: Input
            }], customWidth: [{
                type: Input
            }], isFooterCustomAlignment: [{
                type: Input
            }], isCloseModalOnEscape: [{
                type: Input
            }], isShowCloseButton: [{
                type: Input
            }], isMessageBox: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }], isDraggable: [{
                type: Input
            }], isHandleCloseOnDismiss: [{
                type: Input
            }], isHandleCloseOnAccept: [{
                type: Input
            }], isHandleCloseOnClose: [{
                type: Input
            }], bodyStyleClass: [{
                type: Input
            }], footerStyleClass: [{
                type: Input
            }], isOverflowVisible: [{
                type: Input
            }], isDismissActionVisible: [{
                type: Input
            }], isAcceptActionVisible: [{
                type: Input
            }], onDismiss: [{
                type: Output
            }], onAccept: [{
                type: Output
            }], onClose: [{
                type: Output
            }], onOpen: [{
                type: Output
            }], onAnimationEnd: [{
                type: Output
            }], customFooterContent: [{
                type: ContentChild,
                args: [forwardRef(() => UxModalFooterTagDirective)]
            }], customHeaderContent: [{
                type: ContentChild,
                args: [forwardRef(() => UxModalHeaderTagDirective)]
            }], uxModalEl: [{
                type: ViewChild,
                args: ['modal']
            }], vcCloseButton: [{
                type: ViewChild,
                args: ['closeButton']
            }] } });
/* eslint-disable */
class UxModalBodyTagDirective {
}
/** @nocollapse */ UxModalBodyTagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalBodyTagDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxModalBodyTagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxModalBodyTagDirective, selector: "uxModalBody", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalBodyTagDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'uxModalBody' }]
        }] });
class UxModalFooterTagDirective {
}
/** @nocollapse */ UxModalFooterTagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalFooterTagDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxModalFooterTagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxModalFooterTagDirective, selector: "uxModalFooter", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalFooterTagDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'uxModalFooter' }]
        }] });
class UxModalHeaderTagDirective {
}
/** @nocollapse */ UxModalHeaderTagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalHeaderTagDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxModalHeaderTagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxModalHeaderTagDirective, selector: "uxModalHeader", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalHeaderTagDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'uxModalHeader' }]
        }] });
/* eslint-enable */
class UxModalComponentModule {
}
/** @nocollapse */ UxModalComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxModalComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxModalComponentModule, declarations: [UxModalComponent, UxModalBodyTagDirective, UxModalFooterTagDirective, UxModalHeaderTagDirective], imports: [CommonModule, A11yModule, ScrollingModule, DragDropModule], exports: [UxModalComponent, UxModalBodyTagDirective, UxModalFooterTagDirective, UxModalHeaderTagDirective] });
/** @nocollapse */ UxModalComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalComponentModule, imports: [CommonModule, A11yModule, ScrollingModule, DragDropModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxModalComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, A11yModule, ScrollingModule, DragDropModule],
                    exports: [UxModalComponent, UxModalBodyTagDirective, UxModalFooterTagDirective, UxModalHeaderTagDirective],
                    declarations: [UxModalComponent, UxModalBodyTagDirective, UxModalFooterTagDirective, UxModalHeaderTagDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxModalBodyTagDirective, UxModalComponent, UxModalComponentModule, UxModalFooterTagDirective, UxModalHeaderTagDirective };
